require('@/js/polyfill.js');
import '@utilities/prototypes';
import '../node_modules/vuetify/dist/vuetify.min.css';
import '../node_modules/nouislider/distribute/nouislider.min.css';
import 'promise-polyfill/src/polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import VueResize from 'vue-resize'
import Vuetify from 'vuetify';
import Vuelidate from 'vuelidate'
import axios from 'axios';
import analytics from 'playposit-analytics';
import tinymce from 'tinymce/tinymce';
import { Pagination } from 'element-ui';
import 'element-ui/lib/theme-chalk/pagination.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import 'vue-resize/dist/vue-resize.css'
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/image';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/imagetools';
import whatInput from 'what-input';
import { BFormSelect } from 'bootstrap-vue';
import Player from './Player';
import moment from 'moment';
import _ from 'lodash';
import store from './store';
import PlaypositOffline from '@components/offline';
import PlaypositVideoTranscoder from '@components/video-transcoder';
import PlaypositErrorScreen from '@components/error-screen';
import Tooltip from '@snippets/vue/Tooltip';
import * as PlaypositUtilities from '@utilities';
import '@components/sharedStyles';
import PlayerService from '@/services/PlayerService';
import './fonts/fonts.css';
import SlidoIcon from './components/icons/BarbriSlidoIcon.vue';
import VueSweetalert2 from 'vue-sweetalert2';

// Setting up our namespaced debugging object:
window.PP = {};

const version = '2.80';
Vue.config.productionTip = false;
Vue.component('b-form-select', BFormSelect);
Vue.component('Tooltip', Tooltip);
Vue.use(PlaypositUtilities);
Vue.use(PlaypositErrorScreen);
Vue.use(PlaypositOffline);
Vue.use(PlaypositVideoTranscoder);
Vue.use(Vuex);
Vue.use(VueResize);
Vue.use(Vuelidate);
locale.use(lang);
Vue.component(Pagination.name, Pagination);
Vue.use(Vuetify, {
  theme: {
    primary: '#2196F3',
    secondary: '#0d47a1',
    success: '#1B5E20',
    error: '#AA0000',
    warning: '#FF9800',
    info: '#757575',
  },
  icons: {
    slidoIcon: {
      component: SlidoIcon,
    }
  }
});
Vue.use(VueSweetalert2);

analytics.updateOptions({
  debug: true,
  version: process.env.NODE_ENV === 'production' ? version : `DEV - ${version}`,
});


const errFn = console.error;
console.error = (error, file, line)  => {
  if (process.env.NODE_ENV !== 'production') console.log("MAIN.JS:", error, file, line)
  if (error && file && line) {
    dataLayer.manualLog(`${line} - ${file}`, error);
    errFn(error, file, line)
  }
  else {
    dataLayer.errorLog(error);
    errFn(error);
  }
}
Vue.config.errorHandler = (...error) => {
  if (process.env.NODE_ENV !== 'production') console.log('VUE ERRORHANDLER', error)
  errFn(error);
  let final = {
    name: error[0].name,
    message: error[0].message,
    location: error[1].$options.name,
    scope: error[2],
  };
  dataLayer.vueLog(final);
}

if (!Vue.prototype.$_) Object.defineProperty(Vue.prototype, '$_', { value: _ });

new Vue({
  store,
  PlayerService,
  render: h => h(Player)
}).$mount('#app')
